<template>
  <FlexColumn space="half" class="mb-4">
    <FlexRow align="center" justify="space-between">
      <Label text="経験のあるデータ" bold />
      <SimpleSelectField
          :value="type"
          :items="types"
          width="64px"
          class="mt-0 pt-0 input-type"
          @input="handleInputType"
      />
    </FlexRow>
    <FlexRow wrap>
      <Chip
          v-for="item in items"
          :key="item.value"
          :color="color(item)"
          size="small"
          class="mb-2"
          link no-bold
          @click="handleSelect(item.value)"
      >
        {{item.label}}
      </Chip>
    </FlexRow>
  </FlexColumn>
</template>

<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import FlexRow from "@/components/atoms/FlexRow";
import Chip from "@/components/atoms/Chip";
import {mapGetters} from "vuex";
import SimpleSelectField from "../atoms/SimpleSelectField";
export default {
  name: "ApplicantSearchDataSelect",
  components: {SimpleSelectField, Chip, FlexRow, Label, FlexColumn},
  props: {
    value: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "or"
    }
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    items() {
      return this.consts.dataGoodAt
    },
    color() {
      return (item) => {
        return this.value.includes(item.value) ? 'primary' : undefined
      }
    },
    types() {
      return [
        {label: 'OR', value: 'or'},
        {label: 'AND', value: 'and'},
      ]
    },
  },
  methods: {
    handleSelect(value) {
      if (this.value.includes(value)) {
        this.$emit('input', this.value.filter(val => val !== value))
      } else {
        this.$emit('input', this.value.concat(value))
      }
    },
    handleInputType(value) {
      const type = this.value == null ? undefined : value
      this.$emit('input:type', type)
    }
  }
}
</script>

<style scoped>

</style>